import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_login_log = _resolveComponent("login-log");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_request_log = _resolveComponent("request-log");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_card = _resolveComponent("el-card");
  return _openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      modelValue: _ctx.tabsValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.tabsValue = $event)
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "登录日志",
        name: "first"
      }, {
        default: _withCtx(() => [_createVNode(_component_login_log)]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "请求日志",
        name: "second"
      }, {
        default: _withCtx(() => [_createVNode(_component_request_log, {
          ref: "requestLog"
        }, null, 512)]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]),
    _: 1
  });
}